
export default {
  hero: {
    title: 'About Us',
    subtitle: 'The Daeg International Trade - Your Trusted Partner',
  },
  intro: {
    title: 'About The Daeg International Trade',
    description1: 'The Daeg International Trade is a leading company in import-export and international investment consulting. With over 5 years of experience, we have helped hundreds of customers successfully expand their business and achieve their investment goals.',
    description2: 'We specialize in providing comprehensive solutions from importing Asian goods to Europe, Latvia residency investment consulting, to operating the Asian Alley supermarket chain - a bridge connecting Asian culture with the European market.',
  },
  values: {
    title: 'Core Values',
    subtitle: 'Values that guide all our activities',
    items: [
      {
        title: 'Integrity',
        description: 'We always put honesty and transparency first in every transaction',
      },
      {
        title: 'Dedication',
        description: 'Dedicated to serving and accompanying customers throughout the journey',
      },
      {
        title: 'Professional',
        description: 'Professional working process with a team of experienced experts',
      },
      {
        title: 'Effective',
        description: 'Focus on practical results and sustainable value for customers',
      },
    ],
  },
  asianAlley: {
    title: 'Asian Alley - Our Pride',
    description: 'Asian Alley is our Asian supermarket chain in Latvia, where we bring quality Asian products to the European community. This is not only a business but also a bridge connecting cultures and creating business opportunities for partners.',
    stats: [
      {
        value: '2',
        label: 'Locations',
      },
      {
        value: '€500K+',
        label: 'Annual Revenue',
      },
      {
        value: 'Thousands',
        label: 'of Customers',
      },
    ],
  },
  cta: {
    title: 'Ready to Start?',
    description: 'Contact us today for free consultation on import-export solutions and Latvia residency investment.',
    phone: 'Hotline',
    email: 'Email',
    emailNote: 'Response within 24 hours',
    address: 'Address',
    addressValue: 'Riga, Latvia',
    button: 'Contact Now',
  },
} as const;
